export const AUTH_TOKEN_KEY = "auth_token_default";
export const AUTH_STAY_SIGNED_IN_KEY = "auth_stay_signed_in";

export function hasAuthToken(): boolean {
  return !!window.localStorage.getItem(AUTH_TOKEN_KEY);
}

export function clearAuthStorage(): void {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  window.localStorage.removeItem(AUTH_STAY_SIGNED_IN_KEY);
}
